import { render, staticRenderFns } from "./UserSettingForm.vue?vue&type=template&id=51282a2c&"
import script from "./UserSettingForm.vue?vue&type=script&lang=js&"
export * from "./UserSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports